import { PreUploadFileFromFile } from "@graffer-inc/cloud-gov-core";
import {
  SmartApplyApiError,
  reportUnexpectedError,
} from "@graffer-inc/smart-apply";
import { toast } from "react-toastify";
import Axios, { AxiosResponse } from "axios";

export async function executePreUploadFileWithMultiPart(
  file: PreUploadFileFromFile,
) {
  try {
    return await uploadFileMultiPart(file);
  } catch (e) {
    if (SmartApplyApiError.isRetryable(e)) {
      toast.error(
        "ネットワークエラーが発生しました。再度、ファイルを選択してください。",
      );
      throw e;
    }
    if (
      SmartApplyApiError.isErrorCode(e, "bad_request.invalid_file_mime_type")
    ) {
      toast.error(
        "アップロード可能なファイル形式ではありません。ファイル形式を確認してください。",
      );
      throw e;
    }
    toast.error("ファイルの送信に失敗しました。");
    reportUnexpectedError(e);
    throw e;
  }
}

export async function uploadFileMultiPart(file: PreUploadFileFromFile) {
  const params = new FormData();
  params.append("file", file.data);
  const { data } = await Axios.post<
    FormData,
    AxiosResponse<{ preUploadFileId: string }>
  >("/api/file-upload/pre-upload-stream-file", params, {
    headers: {
      "content-type": "multipart/form-data",
      "X-Upload-File-Content-Type": file.type,
    },
  });
  return data.preUploadFileId;
}
